// extracted by mini-css-extract-plugin
export default {"checkBoxInput":"Checkbox_checkBoxInput__44VsK","customCheckbox":"Checkbox_customCheckbox__sV1sG","checkmark":"Checkbox_checkmark__mLPD-"};